import { render, staticRenderFns } from "./UiYoutubePlayer.vue?vue&type=template&id=c385e38c&scoped=true&"
import script from "./UiYoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./UiYoutubePlayer.vue?vue&type=script&lang=js&"
import style0 from "./UiYoutubePlayer.vue?vue&type=style&index=0&id=c385e38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c385e38c",
  null
  
)

export default component.exports